import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { Table } from "antd";
import axios from "axios";
import { toast } from "react-toastify";
import MainLayout from '../../../layouts/MainLayout'
import { COLOR, FONT } from "../../Config/Color";
import { Api, BaseUrl } from "../../Config/Api";
import AddTicket from "../../Component/AddTicket";
import { getAdminTicketData } from "../../../redux/actions/adminAction";
import { formatDate } from "../../../helpers/frontend";
import moment from "moment";
import { ImagePath } from "../../../config/apiEndPoints";

function MyTickets() {

    const userDetails = JSON.parse(sessionStorage.getItem("userDetails")) || {};
    const token = sessionStorage.getItem("authToken");
    const [isloading, setLoading] = useState(false);
    const logout = () => { };
    const dispatch = useDispatch()

    const [modalOpen, setModalOpen] = useState(false);
    const [ticketData, setTicketData] = useState();
    const [showDialog, setShowDialog] = useState(false);
    const adminTicketsData = useSelector(
        (state) => state?.adminData?.adminTicketsData
    );
    const [query, setQuery] = useState("");

    useEffect(() => {
        dispatch(getAdminTicketData({ path: `tickets/users/${userDetails?.user?.id}` }))
    }, []);
    const handleInputChange = (event) => {
        setQuery(event.target.value);
    };



    const columns = [
        {
            title: "SN.",
            dataIndex: "sn",
            key: "sn",
            render: (text, record, index) => index + 1,
            width: 60,
            fixed: "left",
        },

        {
            title: "Title",
            dataIndex: "title",
            width: 250,
            fixed: "left",
            render: (_, record) => (
                <div >
                    <p className="p-0 m-0 text-capitalize">
                        {record.title}
                    </p>
                    {
                        record?.attachments?.length > 0 &&
                        <a href={ImagePath + record?.attachments[0]}
                            className="text-primary"
                            target="_blank">Attached File Link</a>
                    }
                </div>
            ),
        },

        {
            title: "ISSUE",
            width: 150,
            dataIndex: "description",
            filterMultiple: true,
            key: "description",
        },
        {
            title: "DATE",
            width: 150,
            dataIndex: "created_at",
            key: "created_at",
            render: (text) => (
                <span
                    style={{
                        whiteSpace: "pre-wrap",
                        wordBreak: "break-word",
                        display: "block", // Ensures it takes full width
                        overflowWrap: "break-word",
                    }}
                >
                    {text ? moment(text).format("DD/MMM/YYYY") : "NA"}
                </span>
            ),
        },
        {
            title: "TIME",
            dataIndex: "created_at",
            filtering: false,
            width: 150,
            render: (text) => (
                <span
                    style={{
                        whiteSpace: "pre-wrap",
                        wordBreak: "break-word",
                        display: "block", // Ensures it takes full width
                        overflowWrap: "break-word",
                    }}
                >
                    {text ? moment(text).format("hh:mm A") : "NA"}

                </span>
            ),
        },
        {
            title: "STATUS", dataIndex: "status", filtering: false,
            width: 130,
            render: (text) => (
                <span className={`ticket-status-${text == "pending" ? "pending" : "success"} `}>
                    <i className="ti ti-circle-filled fs-5 me-1">
                    </i>{text}
                </span>
            ),

        },
        {
            title: "REMARK", dataIndex: "remark",
            width: 230,
            render: (text) => (
                <span style={{
                        whiteSpace: "pre-wrap",
                        wordBreak: "break-word",
                        display: "block", // Ensures it takes full width
                        overflowWrap: "break-word",
                    }} className={`text-capitalize `}>
                   {text}
                </span>
            ),

        },

        {
            title: "ACTION",
            width: 100,
            filtering: false,
            render: (_, rowData) => (
                <div>
                    {/* <button
                        className="action-button"
                    // onClick={() => editEmployeeDetails(rowData)}
                    >
                        <i className="fa fa-cross" />
                    </button> */}
                    <button
                        className="action-button"
                        onClick={() => {
                            setTicketData(rowData);
                            setShowDialog(true);
                        }}
                    >
                        <i className="fa fa-trash" />
                    </button>
                </div>
            ),
        },
    ];

    const deleteTicket = async () => {
        setLoading(true);
        try {
            const response = await axios(`${BaseUrl}tickets/${ticketData?.id}`, {
                method: "DELETE",
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${token}`,
                    "X-Company-ID": userDetails?.company_id,
                },
            });
            console.log("response", response);

            setLoading(false)
            if (response?.data?.authenticated === false) {
                toast.error(response?.data?.mssg[0]);
                logout();
            } else {
                if (response?.data?.success === true) {
                    toast.success(response?.data?.mssg);
                    dispatch(getAdminTicketData({ path: `tickets/users/${userDetails?.user?.id}` }))
                    setShowDialog(false);
                } else {
                    toast.error(response?.data?.mssg);
                    setShowDialog(false);
                }
            }
        } catch (error) {
            console.error("API call failed:", error);
            toast.error(error?.response?.data?.message || error?.message)
            setLoading(false);
        }
    };

    const handleClick = () => {
        // setOpen(true)
        setModalOpen(true);
    };
    return (
        <MainLayout>
            <div className="page-wrapper">
                <div className="content h-100">
                    <div>
                        <h2>
                            My Ticket
                        </h2>
                    </div>

                    <div className="p-3 mt-4 bg-white rounded border " >
                        <div className="d-flex align-items-center justify-content-between mb-3">
                            <div className="input-group w-25 m-0">
                                <input type="text" className="form-control"
                                    name="query"
                                    value={query}
                                    onChange={handleInputChange}
                                    placeholder="Search..." />
                                <span className="input-group-text bg-white"><i className="fas fa-search"></i></span>
                            </div>
                            <div className="d-flex align-items-center gap-2">

                                {/* <button
                                    onClick={handleClearFilter}
                                    disabled={isDisabled}
                                    className={`px-3 py-1 rounded flex items-center justify-center transition-colors ${isFilterApplied
                                        ? "bg-blue-500 text-white hover:bg-blue-600"
                                        : "bg-gray-200 text-black"
                                        } ${isDisabled ? "opacity-50 cursor-not-allowed" : ""}`}
                                >
                                    Clear Filter
                                </button> */}
                                <button
                                    className="btn btn-primary gap-2 d-flex align-items-center py-1 fs-14"
                                    onClick={handleClick}
                                >
                                    <i className="fa fa-plus" />
                                    Add Ticket
                                </button>
                            </div>

                        </div>

                        <div
                            style={{
                                marginTop: "20px",
                                width: "100%",
                            }}
                        >
                            <Table
                                columns={columns}
                                dataSource={adminTicketsData?.filter((item) => {
                                    if (query) {
                                        return item?.title?.toLowerCase().includes(query?.toLowerCase())
                                    }
                                    return item
                                })}
                                className="dotted-border-table"
                                rowClassName={() => "custom-row"}
                                bordered={false}
                                tableLayout="fixed"
                                rowKey="key"
                                scroll={{ y: "70vh", x: 1000 }}
                                pagination={{
                                    pageSize: 5,
                                    position: ["bottomRight"],
                                }}
                            />

                            {showDialog && (
                                <div className="dialog-backdrop">
                                    <div className="dialog">
                                        <p>Alert!</p>
                                        <p>Do you want to delete ticket</p>

                                        <div className="dialog-buttons">
                                            <button
                                                onClick={() => { if (!isloading) { deleteTicket() } }}
                                                className="confirm-btn"
                                            >
                                                {isloading ? "Loading.. " : "Yes"}
                                            </button>
                                            <button
                                                onClick={() => setShowDialog(false)}
                                                className="cancel-btn"
                                            >
                                                No
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>

                </div>
            </div>


            <AddTicket open={modalOpen} onClose={() => setModalOpen(false)} />

        </MainLayout>
    )
}

export default MyTickets
